export const TITLE_MAX_LENGTH = 256;

export const DESCRIPTION_MAX_LENGTH = 5000;

export const SHORT_DESCRIPTION_MAX_LENGTH = 400;

export const LOCATION_MAX_LENGTH = 255;
